import colors from "../../base/colors";
import pxToRem from "../../functions/pxToRem";

const { white, grey, primary, transparent } = colors;

const switchButton = {
  defaultProps: {
    disableRipple: true,
    size: "small",
  },
  styleOverrides: {
    root: {
      width: pxToRem(40),
      height: pxToRem(20),
      padding: 0,
      overflow: "visible",
    },

    switchBase: {
      padding: pxToRem(2),
      color: white.main,

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-checked": {
        transform: `translateX(${pxToRem(20)})`,
        color: white.main,

        "&:hover": {
          backgroundColor: transparent.main,
        },

        "& + .MuiSwitch-track": {
          backgroundColor: `${primary.main} !important`,
          borderColor: `${primary.main} !important`,
          opacity: 1,
        },
      },

      "&.Mui-disabled": {
        color: grey[600],
      },

      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: "0.4 !important",
      },
    },

    thumb: {
      width: pxToRem(16),
      height: pxToRem(16),
      backgroundColor: "#ffffff",
      boxShadow: "0 1px 3px rgba(0,0,0,0.45)",
      border: "none",
    },

    track: {
      borderRadius: pxToRem(10),
      backgroundColor: grey[600],
      border: "none",
      opacity: 1,
    },

    checked: {},
  },
};

export default switchButton;
